import { Avatar } from '@creditornot/cb-avatar';
import { cssThemedValue } from '@creditornot/cb-ingredients';
import { MenuActionItem } from '@creditornot/cb-menu';
import React, { MouseEvent } from 'react';
import styled from 'styled-components';

import { ResultType } from './types';

type OnClickOptions = {
  slug: string;
  label: string;
  resultType: ResultType;
  href: string;
  secondLine?: string;
  listimage?: string;
};

type Props = {
  onClick: (options: OnClickOptions) => void;
  closeDropdown?: () => void;
  isActive: boolean;
  label: string;
  slug: string;
  href: string;
  resultType: ResultType;
  secondLine?: string;
  listimage?: string;
};

const Root = styled.div`
  margin-inline: -8px;
`;

const AvatarContainer = styled.div<{ background: boolean; marginRight: boolean }>`
  background-color: ${({ background }) => (background ? cssThemedValue('surfaceMain') : 'none')};
  margin-inline-end: ${({ marginRight }) => (marginRight ? '4px' : '0')};
  border-radius: 50%;

  img {
    object-fit: cover;
  }
`;

const SearchListItem: React.FunctionComponent<Props> = ({
  label,
  slug,
  isActive,
  onClick,
  closeDropdown,
  resultType,
  href,
  secondLine,
  listimage,
}: Props) => {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onClick({ slug, label, resultType, href, secondLine, listimage });
    closeDropdown && closeDropdown();
  };
  return (
    <Root>
      <a href={href} onClick={handleClick}>
        <MenuActionItem
          variant="black"
          leftContent={
            <AvatarContainer background={!listimage} marginRight={!secondLine}>
              <Avatar
                size={'tiny'}
                imgSrc={listimage}
                initials={label
                  .split(' ')
                  .slice(0, 2)
                  .map(word => word.charAt(0))
                  .join('')}
              />
            </AvatarContainer>
          }
          subLabel={secondLine}
          selected={isActive}
        >
          {label}
        </MenuActionItem>
      </a>
    </Root>
  );
};

export default SearchListItem;
